/* eslint-disable */
import * as d3 from 'd3';

export const plot = function (target, plotSettings) {
  const { plot_id, width, height, padding, xMax, yMax, outClass, textClass } =
    plotSettings;

  const zoom = d3
    .zoom()
    .scaleExtent([1, 20]) // This control how much you can unzoom (x0.5) and zoom (x20)
    .translateExtent([
      [0, 0],
      [width * 3, height],
    ])
    //.extent([[0, 0], [PLOT_WIDTH, height]])
    .on('zoom', updateChart);

  // X tengely skála
  const xScale = d3
    .scaleLinear()
    .domain([0, xMax])
    .range([padding, width - padding]);

  //Y tengely skála
  const yScale = d3
    .scaleLinear()
    .domain([0, yMax])
    .range([height - padding, padding]);

  //SVG létrehozás
  d3.selectAll('svg').remove();
  const svg = d3
    .select(target)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .attr('id', plot_id)
    .attr('class', outClass);

  //X tengely létrehozás

  const xAxis = svg
    .append('g')
    .attr('transform', 'translate(0,' + (height - padding) + ')')
    .attr('class', `x-axis ${textClass}`)
    .call(d3.axisBottom(xScale));

  //Y tengely létrehozás
  const yAxis = svg
    .append('g')
    .attr('transform', 'translate(' + padding + ',0)')
    .attr('class', `y-axis ${textClass}`)
    .call(d3.axisLeft(yScale));

  function resetChart() {
    zoom.transform(svg, d3.zoomIdentity);
  }

  // tengely feliratok

  //x
  svg
    .append('text')
    .attr(
      'transform',
      'translate(' + width / 2 + ' ,' + (height - padding / 4) + ')'
    )
    .attr('class', textClass)
    .style('text-anchor', 'middle')
    .text('Retention Time [min]');
  // y
  svg
    .append('text')
    .attr('transform', 'rotate(-90)')
    .attr('y', 0)
    .attr('x', 0 - height / 2 + padding)
    .attr('dy', '1em')
    .style('text-anchor', 'middle')
    .attr('class', textClass)
    .text('Concentration [mg/ml]');

  const clip = svg
    .append('defs')
    .append('SVG:clipPath')
    .attr('id', 'clip')
    .append('SVG:rect')
    .attr('width', width - 2 * padding)
    .attr('height', height - 2 * padding)
    .attr('x', padding)
    .attr('y', padding);

  const scatter = svg
    .append('g')
    .attr('id', 'scatter')
    .attr('clip-path', 'url(#clip)')
    .call(zoom)
    .on('dblclick.zoom', resetChart);

  function updateChart(event) {
    // recover the new scale
    const newX = event.transform.rescaleX(xScale);
    const newY = event.transform.rescaleY(yScale);

    // update axes with these new boundaries
    xAxis.call(d3.axisBottom(newX));
    yAxis.call(d3.axisLeft(newY));
    scatter.selectAll('path').attr('transform', event.transform);
    scatter.selectAll('circle').attr('transform', event.transform);
    scatter.selectAll('.labels').attr('transform', event.translate);
  }
};

export const addCurve = (name, datapoints, curveId, type, plotSettings) => {
  const { plot_id, width, height, colors, textClass, padding, xMax, yMax } =
    plotSettings;

  const svg = d3.select(`#${plot_id}`);
  // X tengely skála
  const xScale = d3
    .scaleLinear()
    .domain([0, xMax])
    .range([padding, width - padding]);

  //Y tengely skála
  const yScale = d3
    .scaleLinear()
    .domain([0, yMax])
    .range([height - padding, padding]);

  // const lineGenerator = d3
  //   .line()
  //   .x(function (d) {
  //     return xScale(d[0]);
  //   })
  //   .y(function (d) {
  //     return yScale(d[1]);
  //   });
  // //.curve(d3.curveCardinal);

  const scatter = svg.select('#scatter');
  const curve = scatter
    .append('g')
    .attr('transform', function (d, i) {
      return 'translate(0,0)';
    })
    .attr('class', 'g_curves')
    .attr('id', `g_curve_${name}`);

  if (type === 'line') {
    curve
      .append('path')
      .datum(datapoints)
      .attr('fill', 'none')
      .attr('stroke', colors[curveId])
      .attr('stroke-width', 0.5)
      .attr(
        'd',
        d3
          .line()
          .x((d) => xScale(d[0]))
          .y((d) => yScale(d[1]))
      );
  }

  if (type === 'path')
    curve
      .append('path')
      .datum(datapoints)
      .attr('class', 'compound')
      .attr(
        'd',
        d3
          .line()
          .x((d) => xScale(d[0]))
          .y((d) => yScale(d[1]))
      )

      .style('fill', colors[curveId])
      .style('opacity', '80%')
      .style('stroke', colors[0])
      .style('stroke-width', 0.25)
      .style('stroke-linejoin', 'round');
  // .on('mouseover', onMouseOver)
  // .on('mouseout', onMouseOut)

  const legend = svg.append('g').attr('class', 'legend');
  legend
    .append('circle')
    .attr('cx', width - padding - 150)
    .attr('cy', padding + 10 + curveId * 25)
    .attr('r', 6)
    .style('fill', colors[curveId]);
  legend
    .append('text')
    .attr('x', width - padding - 130)
    .attr('y', padding + 10 + curveId * 25)
    .attr('class', textClass)
    .attr('alignment-baseline', 'middle')
    .text(name)
    .style('font-size', '1.2rem')
    .style('opacity', '100%');
};

function onMouseOver(d, i) {
  d3.select(this).style('opacity', '100%');
  d3.select(this.parentNode).selectAll('text').style('opacity', '100%');
  d3.select(this.parentNode).selectAll('rect').style('opacity', '100%');
}

function onMouseOut(d, i) {
  d3.select(this).style('opacity', '75%');
  d3.select(this.parentNode).selectAll('text').style('opacity', '0%');
  d3.selectAll('.labels').style('opacity', '100%');
  d3.select(this.parentNode).selectAll('rect').style('opacity', '0%');
}

export const deleteCurveAll = (targetPlot) => {
  const svg = d3.select(`#${targetPlot}`);
  svg.selectAll('.g_curves').remove();
  svg.selectAll('.legend').remove();
};

export const addSelect = (target, plot, compoundNames) => {
  const options = ['overlay'].concat(compoundNames);
  const select = d3.select(`${target}`);
  select.selectAll('.view-options').remove();
  select
    .selectAll('view-selector')
    .data(options)
    .enter()
    .append('option')
    .text(function (d) {
      return d;
    }) // text showed in the menu
    .attr('value', function (d) {
      return d;
    })
    .attr('class', 'view-options');

  d3.select(`${target}`).on('change', function (d) {
    // recover the option that has been chosen
    const selectedOption = d3.select(this).property('value');
    // run the updateChart function with this selected option
    update(selectedOption);
  });

  const update = (selectedOption) => {
    //console.log(selectedOption);
    const svg = d3.select(`#${plot}`);
    if (selectedOption === 'overlay') {
      svg.selectAll('.g_curves').style('opacity', '100%');
    } else {
      svg.selectAll('.g_curves').style('opacity', '0%');
      //console.log(svg.selectAll('.g_curves'));
      svg.selectAll(`#g_curve_${selectedOption}`).style('opacity', '100%');
    }
  };
};
export const rescaleYAxis = (targetPlot, newY, height, padding) => {
  const svg = d3.select(`#${targetPlot}`);
  const yScale = d3
    .scaleLinear()
    .domain([0, newY])
    .range([height - padding, padding]);
  svg.select('.y-axis').call(d3.axisLeft(yScale));
};

export const plotFractions = (fractions, plotSettings) => {
  const { plot_id, width, height, padding, xMax, yMax } = plotSettings;
  const svg = d3.select(`#${plot_id}`);
  svg.selectAll('.fr').remove();

  // X tengely skála
  const xScale = d3
    .scaleLinear()
    .domain([0, xMax])
    .range([padding, width - padding]);

  //Y tengely skála
  const yScale = d3
    .scaleLinear()
    .domain([0, yMax])
    .range([height - padding, padding]);

  const frLines = svg.append('g').attr('class', 'fr');

  fractions.forEach((element) => {
    if (element[2]) {
      frLines
        .append('rect')
        .attr('x', xScale(element[0]))
        .attr('y', yScale(yMax))
        .attr('width', xScale(element[1]) - xScale(element[0]))
        .attr('height', height - 2 * padding)
        .attr('stroke', 'black')
        .attr('fill', '#25bdad')
        .style('opacity', '20%');
      //.on("click", selFR); //ez egyelőre felejtős
    }
    frLines
      .append('rect')
      .attr('x', xScale(element[0]))
      .attr('y', yScale(yMax))
      .attr('width', xScale(element[1]) - xScale(element[0]))
      .attr('height', height - 2 * padding)
      .attr('stroke', 'black')
      .attr('fill', '#69a3b2')
      .style('opacity', '5%');

    //.on("click", selFR);
  });
};

export const removeFractions = (plotSettings) => {
  const { plot_id } = plotSettings;
  const svg = d3.select(`#${plot_id}`);
  svg.selectAll('.fr').remove();
};

export const displayMethodParams = (methodSettings, plotSettings) => {
  const { plot_id, width, height, padding, xMax, yMax } = plotSettings;
  const svg = d3.select(`#${plot_id}`);

  // X tengely skála
  const xScale = d3
    .scaleLinear()
    .domain([0, xMax])
    .range([padding, width - padding]);

  //Y tengely skála
  const yScale = d3
    .scaleLinear()
    .domain([0, yMax])
    .range([height - padding, padding]);

  if (methodSettings.method == 'ex') {
    svg.selectAll('.exLines').remove();
    const exLines = svg.append('g').attr('class', 'exLines');

    exLines
      .append('line')
      .attr('x1', xScale(methodSettings.tsw + methodSettings.t0))
      .attr('y1', yScale(0))
      .attr('x2', xScale(methodSettings.tsw + methodSettings.t0))
      .attr('y2', yScale(yMax))
      .style('stroke-width', 1)
      .style('stroke', 'grey')
      .style('fill', 'none');

    exLines
      .append('line')
      .attr('x1', xScale(methodSettings.tss + methodSettings.t0))
      .attr('y1', yScale(0))
      .attr('x2', xScale(methodSettings.tss + methodSettings.t0))
      .attr('y2', yScale(yMax))
      .style('stroke-width', 1)
      .style('stroke', 'grey')
      .style('fill', 'none');
  }
};
